<template lang="pug">
.m-1
  .header_h 组织架构
  .bottom_tree_table
    .bottom_left
      .header_b(v-if="enableEditOrgTree")
        template
          el-radio-group(v-model="tabPosition", size="small", @change="changeTab")
            el-radio-button(label="部门") 部门
            el-radio-button(label="标签") 标签
          .btn
            img(v-if="editFramework", alt="修改", :src="edit", @click="getEditTree(currentRow)")
            img(v-if="addFramework", alt="新增", :src="add", @click="getAddTree({ parentDeptId: currentRow.deptId })")
            img(v-if="moveFramework", alt="上移", :src="moveUp", @click="moveDept(1)")
            img(v-if="moveFramework", alt="下移", :src="moveDown", @click="moveDept(2)")
            img(v-if="deleFramework", alt="删除", :src="del", @click="getDelete()")
      org-tree(v-if="tabPosition === '部门'", :current-row="currentRow", ref="orgTree", @orgcurrent="currentOrgChangeHandler", @orgData="treeData")
        template(#default="{ data }")
          div
            img(v-if="data.isBranch&&data.isBranch===1",alt="分支机构部门图片", :src="isBranchIcon", style="margin-right: 6px;margin-top: 11px;")
            img(v-else,alt="岗位图片", :src="getIcon(data.deptType)", style="margin-right: 6px")
      el-tree(v-if="tabPosition === '标签'", :data="lableTree", highlight-current, node-key="tagId", ref="lableTre", @node-click="handleNodeClick")
        template(#default="{ data }")
          span.tagNameStyle(:title="data.tagName")
            img(alt="", :src="tag", style="margin-right: 6px")
            div {{ data.tagName }}
    .bottom_right
      el-tabs.header_tab(v-if="tabPosition === '部门'", v-model="currentTabs", style="height: 100%")
        el-tab-pane(label="部门人员", name="departPerson")
          div(v-if="enableEditOrgUser", style="display: inline-block")
            el-button.m-b-1(v-if="addPeople", size="small", type="primary", @click="openPerson") 添加人员
            el-button.m-b-3(v-if="delePeople", :disabled="!removePer", plain, size="small", type="danger", @click="removePerson") 移除人员
            el-button.m-b-2(v-if="setSuper", plain, size="small", type="primary", @click="setHeader") 设置主管
          div(style="float: right; display: flex; align-items: center; margin-right: 20px")
            el-checkbox(v-model="searchQuery.isQueryAll", style="margin-right: 20px", @change="getPersonList(1)") 包含下级部门人员
            el-input(v-model="searchQuery.keyword", clearable, placeholder="请输入姓名或手机号", prefix-icon="el-icon-search", size="small", @input="getPersonList(1)")
          .right_table
            orgPersonTable(:person-table="personTable", @user="openUserDialog", ref="orgPersonTable", :type="1", @handleChange="handleChange", @rowsSelected="handleRowsSelected")
          page.page-2(:page="page", :type="1", @handleCurrentChange="getPersonList", @handleSizeChange="handleSizeChange")
        el-tab-pane(label="部门信息", name="departInfo")
          div
            el-form(label-width="70px", :model="formDepartment", ref="formDepartment")
              el-form-item(label="部门编码")
                p.content {{ formDepartment.deptCode }}
              el-form-item(label="部门名称")
                p.content {{ formDepartment.deptName }}
              el-form-item(label="分管领导")
                div(style="background: #fff; width: 100%; height: 40px; display: flex")
                  div(v-for="divisionLeader in divisionLeaderList", :key="divisionLeader.id")
                    .tree-icon
                      img(alt="", :src="icon3")
                      span {{ divisionLeader.fullName }}
                  el-button(type="text", @click="showAddDivisionLeaderDialog = true") 设置分管领导
              el-form-item(label="部门介绍")
                p.content.remarkStyle {{ formDepartment.remark }}
      div(v-if="tabPosition === '标签' && lableData.tagId", style="height: 100%")
        .top {{ lableData.tagName }}
          span.titleNumStyle {{ titleNum }}
        .down
          .funNav
            div(style="display: flex; align-items: center")
              el-radio-group(v-model="labelTabPosition", size="small", @change="changeLabelTabPosition")
                el-radio-button(label="包含人员") 包含人员
                el-radio-button(label="包含部门") 包含部门
              div(style="margin-left: 30px")
                el-button.m-b-1(size="small", type="primary", @click="openLableData") 添加
                el-button.m-b-3(:disabled="lableSelectionList.length === 0", plain, size="small", type="danger", @click="removePersonData") 移除
            el-input(
              v-model="lableKeyword",
              clearable,
              :placeholder="placeholderFt()",
              prefix-icon="el-icon-search",
              size="small",
              style="width: 220px",
              @input="querySysTagRelation(1)"
            )
          .labelTableStyle
            lableTable(
              :lable-table="lableTable",
              ref="lableTable",
              :type="labelTabPosition === '包含人员' ? 1 : 2",
              @lableHandleChange="lableHandleChange",
              @lableRowsSelected="lableHandleRowsSelected"
            )
            page.page-2(:page="page", :type="1", @handleCurrentChange="querySysTagRelation", @handleSizeChange="handleSizeChange")
      .noDataStyle(v-else)
        img(:src="noDataImg")
  //- 添加部门的弹框
  el-dialog(v-dialogDrag, :before-close="treeClose", :close-on-click-modal="false", :close-on-press-escape="false", :title="treeTitle", :visible.sync="addOrgTree", width="500px")
    el-form.treeFormStyle(label-width="108px", :model="treeForm", ref="treeForm", :rules="rules")
      el-form-item(label="部门名称", prop="deptName")
        el-input(v-model="treeForm.deptName", maxlength="20", placeholder="请输入部门名称", ref="deptName", show-word-limit)
      el-form-item(label="部门编码", prop="deptCode")
        el-input(v-model="treeForm.deptCode", maxlength="20", placeholder="请输入部门编码", show-word-limit)
      el-form-item(label="部门介绍", prop="remark")
        el-input(v-model="treeForm.remark", :autosize="{ minRows: 4, maxRows: 6 }", maxlength="200", placeholder="请输入部门介绍", show-word-limit, type="textarea")
      el-form-item(v-if="isShowRrg()", label="上级部门", prop="parentDeptId")
        el-cascader(v-model="treeForm.parentDeptId", :options="moduleSelectTree", :props="selectPidProp", style="width: 100%")
      el-form-item(v-if="isShowBranch", label="是否分支机构", prop="isBranch")
        el-radio-group(v-model="treeForm.isBranch" :disabled="isBranchDisabled")
          el-radio(:label="0") 否
          el-radio(:label="1") 是
    span.dialog-footer(slot="footer")
      el-button(@click="getReset") 取 消
      el-button(v-if="submitType == 0", type="primary", @click="addDepTree") 确 定
      el-button(v-else, type="primary", @click="editSuccess") 确 定
  //- 添加人员
  el-dialog(
    v-dialogDrag,
    append-to-body,
    :before-close="treeClose",
    :close-on-click-modal="false",
    :close-on-press-escape="false",
    title="添加人员",
    :visible.sync="dialogPerson",
    width="950px"
  )
    el-form.dialog-h(inline)
      el-form-item
        el-input(v-model="searchQuery1.keyword", clearable, placeholder="请输入姓名或手机号", prefix-icon="el-icon-search", size="small", @input="getPersonList1(1)")
      el-form-item(label="账号状态:", style="margin-left: 20px")
        el-select(v-model="searchQuery1.isEnabled", clearable, filterable, size="small", @change="getPersonList1(1)")
          el-option(v-for="item in isqiyongoptions", :key="item.id", :label="item.label", :value="item.id")
    enterprisePerson(:select-person="selectPerson", :type="1", @getCheckBox="getCheckBox" :key="tableIndex")
    page(style="padding: 8px 0" :page="pageAdd", :type="2", @handleCurrentChangeAdd="getPersonList1", @handleSizeChangeAdd="handleSizeChangeAdd")
    span.dialog-footer(slot="footer")
      el-button(@click="dialogPerson = false" size="small") 取 消
      el-button(type="primary", @click="getAddPerson" size="small") 确 定
  //- 新增标签
  el-dialog(
    v-dialogDrag,
    :close-on-click-modal="false",
    :close-on-press-escape="false",
    custom-class="addSysTagMerge",
    :title="sysTagNameTitle",
    top="25vh",
    :visible.sync="addSysTagOpen",
    width="27%"
  )
    .tagName
      el-form(label-position="top", label-width="110px", :model="sysTagNameForm", ref="sysTagNameForm", :rules="sysTagNameRules")
        el-form-item(label="标签名称:", prop="tagName")
          el-input(v-model.trim="sysTagNameForm.tagName", clearable, maxlength="25", placeholder="请输入标签名称", ref="tagName", show-word-limit, size="small")
    div(slot="footer")
      el-button(size="small", @click="addSysTagOpen = false") 取 消
      el-button(size="small", type="primary", @click="addSysTagDetermine") 确 定
  el-dialog(
    v-dialogDrag,
    append-to-body,
    :close-on-click-modal="false",
    :close-on-press-escape="false",
    custom-class="addSysTagMerge",
    title="设置分管领导",
    top="25vh",
    :visible.sync="showAddDivisionLeaderDialog",
    width="27%"
  )
    .tagName
      div(v-for="divisionLeader in divisionLeaderList", :key="divisionLeader.userId")
        .tree-icon(style="margin-top: 10px")
          img(alt="", :src="icon3")
          span {{ divisionLeader.fullName }}
          i.el-icon-close(style="cursor: pointer; margin-left: 4px", @click="deleteDivisionLeader(divisionLeader.userId)")
      .desc 注：最多不超过五人
    .dialog-footer(slot="footer")
      el-button(icon="el-icon-plus", size="small", @click="openPerson") 新增
      el-button(size="small", type="primary", @click="showAddDivisionLeaderDialog = false") 关闭
  //- 设置主管弹框
  dialogSetSuperPerson(:dept-id="currentRow.deptId", ref="setSuperPerson", @fetchData="fetchData")
  addPerson(ref="addPerson", :type="1", @callback="setData")
  addDep(ref="addDep", :type="1", @callback="setData")
</template>
<script>
import orgService from "@/CommonDP/service/org-service";
import sysTagService from "@/CommonDP/service/sysTag-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import orgTree from "@/CommonDP/components/structure/orgTree.vue";
import page from "@/CommonDP/components/paging";
import orgPersonTable from "@/CommonDP/components/structure/orgPersonTable.vue";
import lableTable from "@/CommonDP/components/structure/lableTable.vue";
import enterprisePerson from "@/CommonDP/components/structure/enterprisePerson.vue";
import { mapState } from "vuex";
import configurable from "@/CommonDP/utils/configurable";
import globalParams from "@/CommonDP/utils/globalParams";
import dialogSetSuperPerson from "./dialogSetSuperPerson.vue";
import addPerson from "@/CommonDP/components/send/addPerson.vue";
import addDep from "@/CommonDP/components/send/addDep.vue";
import Drawer from "./drawer.vue";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import asyncCom from "@/CommonDP/commons/asyncCom";
import * as cloneDeep from "lodash/cloneDeep";

const newForm = ({ deptId, deptName, deptCode, remark, parentDeptId, isBranch } = {}) => {
  return {
    deptId: deptId || "",
    deptName: deptName || "",
    deptCode: deptCode || "",
    remark: remark || "",
    parentDeptId: parentDeptId || "",
    isBranch: isBranch || 0
  };
};
const paramsForm = () => ({
  enterpriseId: "",
  tagId: "",
  tagName: ""
});
export default {
  name: "OrgFrameworkConfig",
  components: { orgTree, orgPersonTable, enterprisePerson, page, dialogSetSuperPerson, lableTable, addPerson, addDep },
  data() {
    var tagNameV = (rule, value, callback) => {
      const regExp = new RegExp('[\\\\|/:*<>?"]');
      if (value === "") {
        callback(new Error("标签名称不能为空"));
      } else if (value.length > 25) {
        callback(new Error("标签名称不能大于25个字符"));
      } else if (regExp.test(value)) {
        callback(new Error('标签名称不能包含以下字符:\\ / : * " ? < > |'));
      } else {
        callback();
      }
    };
    return {
      ...configurable.orgFrameworkConfig,
      icon1: require("@/CommonDP/assets/doc/folder_icon.png"),
      icon2: require("@/CommonDP/assets/doc/folder_icon.png"),
      icon3: require("@/CommonDP/assets/doc/role.png"),
      tableIndex: 0,
      rules: {
        deptName: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
        deptCode: [{ required: true, message: "请输入部门编码", trigger: "blur" }],
        isBranch: [{ required: true, message: "请选择是否分支机构", trigger: "change" }]
      },
      enableEditOrgTree: true,
      enableEditOrgUser: true,
      currentTabs: "departPerson",
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      pageAdd: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      frameTree: [], // 树
      addOrgTree: false,
      treeForm: {},
      formDepartment: {},
      currentRow: {},
      currentNode: {},
      dialogPerson: false,
      personTable: [],
      selectPerson: [],
      checkCurrID: {}, //    弹框的节点选择
      outID: undefined, // 部门下的列表节点选择
      removePer: false,
      searchQuery: { keyword: "", isQueryAll: true },
      searchQuery1: { keyword: "", isEnabled: "" },
      isqiyongoptions: [
        { id: "1", label: "启用" },
        { id: "0", label: "禁用" }
      ],
      addFramework: checkPermission(this.$allPerms.ORGFRAMEWORKCONFIG_ADD),
      editFramework: checkPermission(this.$allPerms.ORGFRAMEWORKCONFIG_EDIT),
      deleFramework: checkPermission(this.$allPerms.ORGFRAMEWORKCONFIG_DALE),
      addPeople: checkPermission(this.$allPerms.ORGFRAMEWORKCONFIG_ADDPEOPLE),
      delePeople: checkPermission(this.$allPerms.ORGFRAMEWORKCONFIG_DELEPEOPLE),
      resetPwd: checkPermission(this.$allPerms.PERSONINFO_PWD_RESETPASSWORD),
      moveFramework: checkPermission(this.$allPerms.ORGFRAMEWORKCONFIG_MOVE),
      setSuper: checkPermission(this.$allPerms.ORGFRAMEWORKCONFIG_SETSUPER),
      submitType: "",
      selectPidProp: {
        emitPath: false,
        checkStrictly: true,
        children: "children",
        value: "deptId",
        label: "deptName"
      },
      parentDeptIdRow: "",
      add: require("@/CommonDP/assets/org/add.png"),
      edit: require("@/CommonDP/assets/org/edit.png"),
      del: require("@/CommonDP/assets/org/del.png"),
      moveDown: require("@/CommonDP/assets/org/moveDown.png"),
      moveUp: require("@/CommonDP/assets/org/moveUp.png"),
      tag: require("@/CommonDP/assets/org/tag.png"),
      tabPosition: "部门",
      labelTabPosition: "包含人员",
      lableTable: [],
      lableTree: [],
      addSysTagOpen: false,
      sysTagNameTitle: "新建标签",
      sysTagNameForm: paramsForm(),
      sysTagNameRules: {
        tagName: [{ required: true, validator: tagNameV, trigger: "blur" }]
      },
      lableData: {},
      lableKeyword: "",
      lableSelectionList: [],
      titleNum: "",
      noDataImg: require("@/CommonDP/assets/workProjectBoard/notNotice.png"),
      showAddDivisionLeaderDialog: false,
      isBranchDisabled: false,
      isBranchIcon: require("@/CommonDP/assets/doc/isBranch.png")
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      isShowBranch: state => state.enterprise.isShowBranch
    }),
    treeTitle() {
      return ["添加", "修改"][this.submitType];
    },
    divisionLeaderList() {
      return this.formDepartment.chargeLeaderList || [];
    },
    // 下拉父级
    moduleSelectTree() {
      const list = this.frameTree.map((item) => {
        if (item.children.length === 0) {
          item.isLeaf = true;
          return {
            deptName: item.deptName,
            deptId: item.deptId,
            isLeaf: true
          };
        } else {
          return item;
        }
      });
      return [...list];
    }
  },
  mounted() {
    const orgReadonly = globalParams.getFn("org.readonly", false);
    const orgUserReadonly = globalParams.getFn("org.user.readonly", false);
    this.enableEditOrgTree = !orgReadonly;
    this.enableEditOrgUser = !orgUserReadonly;
  },
  methods: {
    async deleteDivisionLeader(id) {
      await this.$confirm("此操作将删除分管领导，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      orgService.delDivisionLeader(this.currentRow.deptId, id).then(() => {
        this.getOrgInfo();
      });
    },
    addDivisionLeader() {
      orgService
        .addDivisionLeader(
          this.currentRow.deptId,
          this.checkCurrID.map((item) => item.userId)
        )
        .then(() => {
          this.dialogPerson = false;
          this.getOrgInfo();
        });
    },
    isShowRrg() {
      if (this.submitType === 1 && this.parentDeptIdRow === "0") return false;
      else return true;
    },
    // 添加目录树
    addDepTree() {
      const { deptName, deptCode, remark, parentDeptId, isBranch } = this.treeForm;
      const params = {
        deptName,
        parentDeptId,
        deptCode,
        remark,
        enterpriseId: this.enterpriseId,
        isBranch
      };
      this.$refs.treeForm.validate((valid) => {
        if (valid) {
          orgService.newAddTree(params).then(() => {
            this.$refs.orgTree.getFrameTree();
            this.getReset();
            this.currentRow = {};
            this.personTable = [];
            this.formDepartment = {};
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑目录树
    async getEditTree(row) {
      if (this.tabPosition === "部门") {
        const a = disablePrompt();
        if (a) {
          this.addOrgTree = true;
          this.submitType = 1;
          this.treeForm = newForm(row);
          this.isBranchDisabled = false;
          if (this.currentRow.isBranch === 0) {
            await this.getUpFindIsBranch(this.currentNode);
            await this.getDownFindIsBranch(this.currentNode.data);
          }
        }
      } else {
        if (!this.lableData.tagId) {
          this.$message.warning("请选择一条编辑的数据");
          return;
        }
        this.sysTagNameTitle = "编辑标签";
        this.addSysTagOpen = true;
        await this.$nextTick();
        this.$refs.sysTagNameForm.clearValidate();
        this.sysTagNameForm = { ...this.lableData };
      }
    },
    // 修改后
    async editSuccess() {
      const { deptName, deptCode, remark, deptId, parentDeptId, isBranch } = this.treeForm;
      const params = { deptId, parentDeptId, deptName, deptCode, remark, isBranch };
      await this.$refs.treeForm.validate();
      if (parentDeptId !== deptId) {
        await orgService.updateOrgInfo(params);
        this.$refs.orgTree.getFrameTree();
        this.getReset();
        this.formDepartment = {};
      } else {
        this.$message.warning("所选上级部门与该部门为同一个，请重新选择");
      }
    },
    // 清空表单
    getReset() {
      this.$refs.treeForm.resetFields();
      this.addOrgTree = false;
    },
    treeData(data) {
      this.frameTree = data;
    },
    // 选中节点
    currentOrgChangeHandler(val, node) {
      this.currentNode = node;
      this.personTable = [];
      this.currentRow = val;
      this.page.totalCount = 0;
      this.parentDeptIdRow = val.parentDeptId;
      this.removePer = false;
      this.getOrgInfo();
      this.getPersonList();
    },
    // 组织列表详情
    async getOrgInfo() {
      const e = this.currentRow;
      const { data } = await orgService.orgInfo(e.deptId);
      this.formDepartment = data;
    },
    async getAddTree(treeForm = {}) {
      if (this.tabPosition === "部门") {
        const a = disablePrompt();
        if (a) {
          this.addOrgTree = true;
          this.submitType = 0;
          this.treeForm = newForm(treeForm);
          await this.$nextTick();
          this.$refs.deptName.focus();
          this.$refs.treeForm.clearValidate();
          this.isBranchDisabled = false;
          await this.getUpFindIsBranch(this.currentNode);
        }
      } else {
        this.sysTagNameTitle = "新建标签";
        this.addSysTagOpen = true;
        await this.$nextTick();
        this.sysTagNameForm = paramsForm();
        this.$refs.tagName.focus();
        this.$refs.sysTagNameForm.clearValidate();
      }
    },
    getUpFindIsBranch(data) {
      if (data.data.isBranch) {
        this.isBranchDisabled = true;
      } else if (data.parent && data.parent.parent) {
        this.getUpFindIsBranch(data.parent);
      }
    },
    getDownFindIsBranch(data) {
      data.children.forEach(ele => {
        if (ele.isBranch) {
          this.isBranchDisabled = true;
        } else if (ele.children.length > 0) {
          this.getDownFindIsBranch(ele);
        }
      });
    },
    treeClose() {
      this.addOrgTree = false;
      this.dialogPerson = false;
    },
    // 刪除目录
    getDelete() {
      if (this.tabPosition === "部门") {
        const a = disablePrompt();
        if (a) {
          const row = this.currentRow;
          if (row.parentDeptId !== "0") {
            this.$confirm(`您确定删除${row.deptName}吗，是否继续？`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              closeOnClickModal: false,
              closeOnPressEscape: false
            }).then(() => {
              orgService.deleteOrgTree(row.deptId).then(() => {
                this.$refs.formDepartment.resetFields();
                this.$message.success("删除成功");
                this.currentRow = {};
                this.$refs.orgTree.queryFrameTree();
              });
            });
          } else {
            this.$message.warning("根目录不能删除");
          }
        }
      } else {
        if (!this.lableData.tagId) {
          this.$message.warning("请选择一条删除的数据");
          return;
        }
        const num1 = Number(this.titleNum.split("，")[0].split("个")[0]);
        const num2 = Number(this.titleNum.split("，")[1].split("个")[0]);
        if (num1 !== 0 || num2 !== 0) {
          this.$message.warning("请先移出标签中的所有部门及成员,再删除标签");
          return;
        }
        this.$confirm(`您确定删除吗，是否继续？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(async () => {
          await sysTagService.deleteSysTag(this.lableData.tagId);
          this.$message.success("删除成功");

          this.querySysTagList();
        });
      }
    },
    // 部门下的添加人员
    openPerson() {
      const a = disablePrompt();
      if (a) {
        this.dialogPerson = true;
        this.getPersonList1(1);
      }
    },
    // 获取可添加的人员
    async getPersonList1(index) {
      const {
        pageAdd: { pageSize },
        searchQuery1: { keyword, isEnabled },
        enterpriseId,
        currentRow
      } = this;
      var params = {
        keyword,
        pageNum: index,
        pageSize,
        enterpriseId,
        isEnabled,
        deptId: currentRow.deptId
      };
      const { data, totalCount, pageNum } = await orgService.personList(params);
      this.pageAdd.pageNum = pageNum;
      this.pageAdd.totalCount = totalCount;
      this.selectPerson = data;
      this.tableIndex++;
    },
    // 添加人员成功后
    async getAddPerson() {
      if (this.showAddDivisionLeaderDialog) {
        this.addDivisionLeader();
        return;
      }
      const dePerID = this.currentRow;
      const deuserID = this.checkCurrID;
      if (deuserID && deuserID.length > 0) {
        const userIds = deuserID.map(({ userId }) => userId);
        const params = {
          deptId: dePerID.deptId,
          userIds
        };
        const res = await orgService.orgUser(params);
        if (res.result === "0") this.$message.success("添加人员成功");
        this.getPersonList();
        this.searchQuery1.keyword = "";
        this.dialogPerson = false;
        this.checkCurrID = {};
      } else {
        this.$message.warning("请选择人员");
      }
    },
    handleSizeChangeAdd(val) {
      this.pageAdd.pageSize = val;
      this.getPersonList1(1);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      if (this.tabPosition === "部门") {
        this.getPersonList(1);
      } else {
        this.querySysTagRelation(1);
      }
    },
    // 部门下的人员列表
    async getPersonList(index = 1) {
      this.removePer = false;
      const dep = this.currentRow;
      const {
        page: { pageSize },
        searchQuery: { keyword, isQueryAll },
        enterpriseId
      } = this;
      const params = {
        deptId: dep.deptId,
        keyword,
        pageNum: index,
        pageSize,
        enterpriseId,
        isQueryAll: isQueryAll ? 1 : 0
      };
      const { data, totalCount, pageNum } = await orgService.orgUserList(params);
      this.page.pageNum = pageNum;
      this.page.totalCount = totalCount;
      this.personTable = data;
      this.personTable.map((item) => {
        for (const a of item.deptList) {
          a.rowID = this.currentRow.deptId;
        }
      });
    },
    // 移除部门下的人员
    removePerson() {
      const a = disablePrompt();
      if (a) {
        const deptId = this.currentRow.deptId;
        const userId = this.outID.userId;
        const enterpriseId = this.enterpriseId;
        this.$confirm("此操作将删除此人员，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const params = { userId, deptId, enterpriseId };
          orgService.delOrgUser(params).then(() => {
            this.getPersonList();
            this.$message({
              showClose: true,
              type: "success",
              message: "删除成功"
            });
            this.removePer = false;
          });
        });
      }
    },
    async openUserDialog(row) {
      await asyncCom(Drawer, { info: cloneDeep(row) });
      this.fetchData();
    },
    // 部门下得列表节点
    handleChange(val) {
      this.outID = val;
      this.removePer = true;
    },
    lableHandleChange(val) {
      // TODO;
    },
    handleRowsSelected(rows) {
      // TODO
    },
    lableHandleRowsSelected(rows) {
      this.lableSelectionList = rows;
    },
    // 弹框中的表格行选中
    getCheckBox(val) {
      this.checkCurrID = val;
    },
    //  移动部门位置  moveType: 1为上移 2为下移
    async moveDept(moveType) {
      if (this.tabPosition === "部门") {
        const a = disablePrompt();
        if (a) {
          if (!this.currentRow) {
            this.$message.warning("请选择一条移动的数据");
            return;
          }
          const { deptId } = this.currentRow;
          await orgService.moveOrg(deptId, moveType);
          this.$refs.orgTree.getFrameTree(1);
        }
      } else {
        if (!this.lableData.tagId) {
          this.$message.warning("请选择一条移动的数据");
          return;
        }
        const { tagId } = this.lableData;
        await sysTagService.moveSysTag(moveType, tagId);
        this.$message.success("移动成功");
        this.querySysTagList();
      }
    },
    // 设置主管
    setHeader() {
      this.$refs.setSuperPerson.setSuperShow = true;
    },
    fetchData(val) {
      this.getPersonList(val || this.page.pageIndex);
    },
    async querySysTagList() {
      this.lableData = {};
      const { data } = await sysTagService.getSysTagList(this.enterpriseId);
      this.lableTree = data;

      if (data.length) {
        this.$nextTick(() => {
          this.lableData = data[0];
          this.$refs.lableTre.setCurrentKey(data[0].tagId);
          this.querySysTagRelation(1);
        });
      }
    },
    handleNodeClick(data) {
      this.lableData = data;
      this.page.totalCount = 0;
      this.querySysTagRelation(1);
    },
    changeTab(val) {
      if (val === "标签") {
        this.labelTabPosition = "包含人员";
        this.querySysTagList();
      }
    },
    addSysTagDetermine() {
      this.$refs.sysTagNameForm.validate(async (valid) => {
        if (valid) {
          this.sysTagNameForm.enterpriseId = this.enterpriseId;
          if (this.sysTagNameTitle === "新建标签") {
            await sysTagService.addSysTag(this.sysTagNameForm);
            this.$message.success("新建成功");
          } else {
            await sysTagService.updateSysTag(this.sysTagNameForm);
            this.$message.success("编辑成功");
          }
          this.querySysTagList();
          this.addSysTagOpen = false;
        } else {
          return false;
        }
      });
    },
    async querySysTagRelation(index = 1) {
      if (this.lableData.tagId) {
        const {
          page: { pageSize }
        } = this;
        const params = {
          keyword: this.lableKeyword,
          pageNum: index,
          pageSize,
          tagId: this.lableData.tagId,
          type: this.labelTabPosition === "包含人员" ? 1 : 2
        };
        const { data, totalCount, pageNum } = await sysTagService.getSysTagRelation(params);
        this.page.pageNum = pageNum;
        this.page.totalCount = totalCount;
        this.lableTable = data;
        this.getSysTagRelationNum();
      }
    },
    async getSysTagRelationNum() {
      const { tagId } = this.lableData;
      const { data } = await sysTagService.getSysTagRelationNum(tagId);
      this.titleNum = data;
    },
    changeLabelTabPosition() {
      this.lableKeyword = "";
      this.lableSelectionList = [];
      this.querySysTagRelation(1);
    },
    async openLableData() {
      if (this.labelTabPosition === "包含人员") {
        const props = {
          max: Infinity,
          codePri: ["User"]
        };
        const data = await openMember(props);
        const relaIds = data.map(({ userId }) => userId);
        const { tagId } = this.lableData;
        await sysTagService.addSysTagRelation({ relaIds, tagId, type: 1 });
        this.$message.success("添加成功");
        this.querySysTagRelation(1);
      } else {
        const props = {
          max: Infinity,
          codePri: ["Dept"]
        };
        const data = await openMember(props);
        const relaIds = data.map(({ userId }) => userId);
        const { tagId } = this.lableData;
        await sysTagService.addSysTagRelation({ relaIds, tagId, type: 2 });
        this.$message.success("添加成功");
        this.querySysTagRelation(1);
      }
    },
    removePersonData() {
      if (this.lableSelectionList.length === 0) {
        this.$message.warning("请选择要移除的数据");
        return;
      }
      this.$confirm(`您确定移除吗，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        const { tagId } = this.lableData;
        const relaIds = this.lableSelectionList.map((v) => v.relaId);
        const params = {
          relaIds,
          tagId,
          type: this.labelTabPosition === "包含人员" ? 1 : 2
        };
        await sysTagService.deleteSysTagRelation(params);
        this.$message.success("移除成功");
        this.querySysTagRelation(1);
      });
    },
    // 设置要发送的数据
    setData(data) {
      // const relaIds = data.map((v) => v.deptId);
      // if (data.length >= 1) {
      //   this.confirmAddPerson(relaIds);
      // }
    },
    // async confirmAddPerson(relaIds) {
    //   const { tagId } = this.lableData;
    //   await sysTagService.addSysTagRelation({ relaIds, tagId, type: this.labelTabPosition === '包含人员' ? 1 : 2 });
    //   this.$message.success("添加成功");
    //   this.querySysTagRelation(1);
    // },
    placeholderFt() {
      return this.labelTabPosition === "包含人员" ? "请输入姓名/账号" : "请输入部门名称/部门编码";
    }
  }
};
</script>
<style lang="scss">
.bottom_tree_table {
  .el-tabs__content {
    height: calc(100% - 40px - var(--middle-space)) !important;
    padding: 0 var(--big-space);
  }
  .el-tabs__header {
    .el-tabs__nav{
      margin-left: var(--big-space);
    }
  }
}
</style>
<style lang="scss" scoped>
$top-height: 30px;
$left-width: 340px;
.desc {
  margin-top: 40px;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
}
.tree-icon {
  display: flex;
  align-items: center;
  margin-right: 10px;
  font-size: 14px;
  img {
    font-size: 14px;
    margin-right: 5px;
  }
  span {
    font-size: 14px;
  }
}
.m-1 {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header_h {
    font-size: 16px;
    padding: var(--middle-space) var(--big-space);
    font-weight: 600;
    letter-spacing: 1px;
    border-bottom: 1px solid #ebefff;
    .icon_1 {
      color: #cd6d6d;
      font-size: 20px;
    }
  }

  .bottom_tree_table {
    height: 1px;
    flex: 1 0 1px;
    position: relative;
    .bottom_left {
      height: 100%;
      overflow: auto;
      width: $left-width;
      padding: var(--middle-space) var(--big-space);
      border-right: 1px solid #ebefff;
      display: flex;
      flex-direction: column;
      .header_b {
        display: flex;
        margin-bottom: var(--middle-space);
        align-items: center;
        .btn {
          img {
            margin-left: 15px;
            cursor: pointer;
          }
        }
      }
      .orgTree{
        height: 1px;
        flex: 1 0 1px;
        overflow: hidden;
        &:hover{
          overflow: auto;
        }
      }
      .tagNameStyle {
        display: flex;
        align-items: center;
        width: 340px;
        overflow: hidden;
        padding-right: 25px;
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .bottom_right {
      position: absolute;
      left: $left-width;
      top: 0;
      right: 0;
      bottom: 0;
      padding: var(--small-space) 0 0 0px;
      /deep/.el-form-item__content {
        background: #f7f8fa;
      }

      .content {
        font-size: 14px;
        line-height: 20px;
        color: #58667b;
        padding: 5px 0 5px 5px;
        user-select: none;
        width: 100%;
        font-size: 14px;
        line-height: 30px;
        max-height: 100px;
        min-height: 40px;
        color: var(--key-color);
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .remarkStyle {
        height: 100px;
      }
      .top {
        height: 40px;
        line-height: 32px;
        border-bottom:1px solid #E5E8F1;
        padding-left: var(--big-space);
        color: var(--key-color);
        font-weight: 600;
        font-size: 16px;
        .titleNumStyle {
          font-size: 15px;
          margin-left: 20px;
          color: #b4b4c3;
        }
      }
      .down{
        padding: var(--middle-space) var(--big-space) 0;
        height: calc(100% - 40px);
        .funNav{
          display: flex;
          justify-content: space-between;
        }
        .labelTableStyle{
          margin-top: var(--middle-space);
          height: calc(100% - 64px - var(--middle-space) * 3);
        }
      }
      .noDataStyle {
        width: 100%;
        height: calc(100vh - 122px);
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .treeFormStyle{
    /deep/ .el-form-item__error{
      padding-top:1px
    }
  }
}
.dialog-h {
  margin-top: -5px;
}
.right_table {
  position: absolute;
  right: var(--big-space);
  left: var(--big-space);
  top: calc(32px + var(--middle-space));
  bottom: calc(32px + var(--middle-space) * 2);
}
.page-2 {
  padding: var(--middle-space) var(--big-space);
  position: absolute;
  right: 0;
  bottom: 0;
}
/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
.header_tab /deep/ .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #ebefff;
}
</style>
